import { render, staticRenderFns } from "./Tinder.vue?vue&type=template&id=7f194e9c&scoped=true&"
import script from "./Tinder.vue?vue&type=script&lang=js&"
export * from "./Tinder.vue?vue&type=script&lang=js&"
import style0 from "./Tinder.vue?vue&type=style&index=0&id=7f194e9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f194e9c",
  null
  
)

export default component.exports